<div class="am-bag-status-content" [ngSwitch]="statusBag">
  <span *ngSwitchCase="StatusBag.NONE">{{'bagsSelection.bag-status.none' | translate}}</span>
  <span *ngSwitchCase="StatusBag.INCLUDE">{{'bagsSelection.bag-status.include' | translate}}</span>
  <div *ngSwitchCase="StatusBag.PAID" class="am-bag-status-block">
    <img src="./assets/images/bags/icon-bag-check.svg" alt="">
    <span>{{'bagsSelection.bag-status.paid' | translate}}</span>
  </div>
  <div *ngSwitchCase="StatusBag.REDEEMED_APPLIED" class="am-bag-status-block">
    <img src="./assets/images/bags/icon-bag-gift-success.svg" alt="">
    <span>{{'bagsSelection.bag-status.redeemedAplied' | translate}}</span>
  </div>
  <div *ngSwitchCase="StatusBag.TO_PAY" class="am-bag-status-block">
    <strong>{{totalAmount | amCurrency:'':'symbol':'0.0'}}</strong>
    <span>{{currencyCode}}</span>
  </div>
</div>

